import "react-datepicker/dist/react-datepicker.css";
import ActionsMenu from '../../Shared/Components/ActionsMenu';
import AlertDismissible from '../../Shared/Components/AlertDismissible';
import Breadcrumbs from '../../Shared/Components/Breadcrumbs';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import DatePicker from "react-datepicker";
import Form from 'react-bootstrap/Form';
import Layout from '../../Shared/Layout/LayoutAdmin';
import PaginationList from '../../Shared/Components/PaginationList';
import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row';
import es from 'date-fns/locale/es';
import { Inertia } from '@inertiajs/inertia';
import { Link, usePage } from '@inertiajs/inertia-react';
import { hasPermission } from '../../utils/Permissions';
import { registerLocale } from "react-datepicker";
registerLocale('es', es)

const List = ({ items }) => {
    const { flash } = usePage().props
    const data = items.data;

    const query = new URL(window.location).searchParams;
    const [policy, setPolicy] = useState(query.get("polipolizacy") || '');
    const [status, setStatus] = useState(query.get("estatus") || '');
    const [contractor, setContractor] = useState(query.get("contratante") || '');
    const [insured, setInsured] = useState(query.get("asegurado") || '');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');

    useEffect(() => {
        setPolicy(query.get("poliza") || '');
        setStatus(query.get("estatus") || '');
        setContractor(query.get("contratante") || '');
        setInsured(query.get("asegurado") || '');
        setDateFrom(query.get("date_from") ? moment(query.get("date_from")).toDate() : moment().subtract(1, 'days').toDate());
        setDateTo(query.get("date_to") ? moment(query.get("date_to")).toDate() : moment().toDate());
    }, []);

    function handleChangePolicy(e) {
        setPolicy(e.target.value);
    }
    function handleChangeStatus(e) {
        setStatus(e.target.value);
    }
    function handleChangeContractor(e) {
        setContractor(e.target.value);
    }
    function handleChangeInsured(e) {
        setInsured(e.target.value);
    }

    function search() { // search
        const start = moment(dateFrom).startOf('day');
        const end = moment(dateTo).startOf('day');

        Inertia.get(route('insurance.application.list'),
            {
                date_from: start.isValid() ? start.format('YYYY-MM-DD') : '',
                date_to: end.isValid() ? end.format('YYYY-MM-DD') : '',
                poliza: policy,
                estatus: status,
                contratante: contractor,
                asegurado: insured,
            },
            {
                preserveState: true,
                preserveScroll: true,
                replace: true
            }
        )
    }

    async function generateOiiFile() {
        try {
            const response = await axios.get(route('insurance.application.generate.oii'), {
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `consulta_oii.xlsx`;
            link.click();
            window.URL.revokeObjectURL(link.href);

            Inertia.reload({ only: ['items'] })
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Hubo un detalle con el archivo",
            });
        }
    }

    return (
        <div>
            <div className="mb-7 mt-7">
                <Breadcrumbs currentPath="/admin/quotes/applications" />
            </div>
            <Col className="mb-2 px-1 d-flex justify-content-between">
                <h2>Listado de Solicitudes</h2>

                {(hasPermission('quotes.applications.policy.massive_create_excel') ||
                hasPermission('quotes.applications.policy.massive_create_txt') ||
                hasPermission('quotes.applications.policy.add') ||
                hasPermission('quotes.applications.policy.create_oii_file') ||
                hasPermission('quotes.applications.policy.upload_oii_file')) && (
                    <ActionsMenu size="sm">
                        <div className="text-md-center px-7 py-5">
                            {hasPermission('quotes.applications.policy.massive_create_excel') && (
                                <div className={(hasPermission('quotes.applications.policy.massive_create_txt') || hasPermission('quotes.applications.policy.add') || hasPermission('quotes.applications.policy.create_oii_file') || hasPermission('quotes.applications.policy.upload_oii_file')) ? 'mb-4' : ''}>
                                    <Link href={route('policy-application.import.create')}>Carga/Creación de Polizas</Link>
                                </div>
                            )}
                            {hasPermission('quotes.applications.policy.massive_create_txt') && (
                                <div className={(hasPermission('quotes.applications.policy.add') || hasPermission('quotes.applications.policy.create_oii_file') || hasPermission('quotes.applications.policy.upload_oii_file')) ? 'mb-4' : ''}>
                                    <Link href={route('policy-application.import_text.create')}>Carga/Creación de Polizas desde Txt</Link>
                                </div>
                            )}
                            {hasPermission('quotes.applications.policy.add') && (
                                <div className={(hasPermission('quotes.applications.policy.create_oii_file') || hasPermission('quotes.applications.policy.upload_oii_file')) ? 'mb-4' : ''}>
                                    <Link href={route('insurance.application.new')}>Agregar Solicitud</Link>
                                </div>
                            )}
                            {hasPermission('quotes.applications.policy.create_oii_file') && (
                                <div className={hasPermission('quotes.applications.policy.upload_oii_file') ? 'mb-4' : ''}>
                                    <Link href='#' onClick={(e) => { e.preventDefault(); generateOiiFile() }}>Generar Archivo OII</Link>
                                </div>
                            )}
                            {hasPermission('quotes.applications.policy.upload_oii_file') && (
                                <div>
                                    <a href={route('insurance.application.import.oii')}>Carga de Archivo OII</a>
                                </div>
                            )}
                        </div>
                    </ActionsMenu>
                )}
            </Col>
            {flash.success && (
                <AlertDismissible message={flash.success} type="success" />
            )}
            {flash.error && (
                <AlertDismissible message={flash.error} type="danger" />
            )}

            <Row className="mb-4">
                <Col sm={2}>
                    <Form.Label className="mb-0" size="sm">Número de Póliza</Form.Label>
                    <Form.Control value={policy} placeholder='' type="text" onChange={handleChangePolicy} size="sm" />
                </Col>
                <Col sm={1}>
                    <Form.Label className="mb-0">Status</Form.Label>
                    <Form.Select className="form-control" value={status} onChange={handleChangeStatus} size="sm">
                        <option value={''}></option>
                        <option value={'created'}>Creada</option>
                        <option value={'rejected'}>Rechazada</option>
                        <option value={'evaluation'}>Evaluación</option>
                        <option value={'requirement'}>Requisito</option>
                        <option value={'emission'}>Emitido</option>
                    </Form.Select>
                </Col>
                <Col sm={2}>
                    <Form.Label className="mb-0">Contratante</Form.Label>
                    <Form.Control value={contractor} placeholder='Contratante' type="text" onChange={handleChangeContractor} size="sm" />
                </Col>
                <Col sm={2}>
                    <Form.Label className="mb-0">Asegurado</Form.Label>
                    <Form.Control value={insured} placeholder='Asegurado' type="text" onChange={handleChangeInsured} size="sm" />
                </Col>
                <Col sm={2}>
                    <Form.Label className="mb-0">Fecha Inicial</Form.Label>
                    <DatePicker popperPlacement="bottom-start" className="form-control form-control-sm" locale="es" selected={dateFrom} onChange={(date) => setDateFrom(date)} dateFormat="dd/MM/yyyy" />
                </Col>
                <Col sm={2}>
                    <Form.Label className="mb-0">Fecha Final</Form.Label>
                    <DatePicker popperPlacement="bottom-start" className="form-control form-control-sm" locale="es" selected={dateTo} onChange={(date) => setDateTo(date)} dateFormat="dd/MM/yyyy" />
                </Col>
                <Col sm={1}>
                    <Form.Label className="mb-0 d-block">&nbsp;</Form.Label>
                    <Button onClick={search} variant="primary" className='me-3 btn-sm' type="submit" >Filtrar</Button>
                </Col>
            </Row>

            <div className="card card-flush h-md-100">
                <div className="card-body pt-6">
                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">

                            <thead>
                                <tr className="fs-7 fw-bold text-gray-400 border-bottom-0">
                                    <th className="text-start">NÚMERO DE FOLIO</th>
                                    <th className="min-w-175px text-start">ASESOR/EMPLEADO</th>
                                    <th className="min-w-175px text-start">CONTRATANTE</th>
                                    <th className="min-w-175px text-start">ASEGURADO</th>
                                    <th className="text-start">PRODUCTO</th>
                                    <th className="text-start">ESTATUS</th>
                                    <th className="text-start">OII</th>
                                    <th className="w-50px text-end"></th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.length === 0 && (
                                    <tr>
                                        <td
                                            className="px-6 py-3 text-center text-gray-800 fw-bold mb-1 fs-6"
                                            colSpan="6"
                                        >
                                            No hay datos.
                                        </td>
                                    </tr>
                                )}
                                {data.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="text-gray-800 fw-bold mb-1 fs-6">{item.application_number}</td>
                                            <td className="text-gray-800 fw-bold mb-1 fs-6">{item.asesor?.user?.name} {item.asesor?.lastname_ap} {item.asesor?.lastname_am}</td>
                                            <td className="text-gray-800 fw-bold mb-1 fs-6">{item.contractor_name + " " + item.contractor_last_name + " " + item.contractor_mother_last_name}</td>
                                            <td className="text-gray-800 fw-bold mb-1 fs-6">{item.coverage_name + " " + item.coverage_lastname_paternal + " " + item.coverage_lastname_maternal}</td>
                                            <td className="text-gray-800 fw-bold mb-1 fs-6">{item.product_type.name}</td>
                                            <td className="text-gray-800 fw-bold mb-1 fs-6">{item.status}</td>
                                            <td className="text-gray-800 fw-bold mb-1 fs-6">{item.oii}</td>
                                            <td>
                                                <div className="d-flex justify-content-around">
                                                    <div className='mx-2'>
                                                        {hasPermission('quotes.applications.policy.edit') && (
                                                            <Link href={route("insurance.application.edit", item.id)}>Editar</Link>
                                                        )}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <PaginationList links={items.links} />
                </div>
            </div>
        </div>
    );
}

List.layout = page => <Layout children={page} title="Solicitudes" />

export default List
